
import { styled } from '@mui/system';

export const Container = styled('div')({
    border: '0.5px solid grey',
    borderRadius: '8px',
    display: 'block',
    backgroundColor: '#fff',
    letterSpacing: '.1px',
    marginBottom: '15px',
    padding: '30px',
    overflow: 'hidden',
});
